import type { Category } from "@/constants/categories";

type JamSpreadProduct = {
  id: string;
  name: string;
  categorySlug: Category["slug"];
  brand: string;
  price: number;
  unit: string;
  image: string;
};

const IMG = {
  jam: "https://images.unsplash.com/photo-1627483298232-9ef15f7b3b90?crop=entropy&cs=srgb&fm=jpg&q=85",
};

const item = (
  id: string,
  name: string,
  brand: string,
  unit: string,
  price: number,
): JamSpreadProduct => ({
  id,
  name,
  categorySlug: "jams-spreads",
  brand,
  unit,
  price,
  image: IMG.jam,
});

export const JAMS_SPREADS_PRODUCTS: JamSpreadProduct[] = [
  item("js-skippy-creamy", "Skippy Creamy Peanut Butter", "Skippy", "462g", 8.99),
  item("js-skippy-extra-crunchy", "Skippy Extra Crunchy Peanut Butter", "Skippy", "462g", 8.99),
  item("js-skippy-natural-less-sod", "Skippy Natural Less Sodium & Sugar Peanut Butter", "Skippy", "425g", 9.49),
  item("js-skippy-natural-chunky", "Skippy Natural Chunky Peanut Butter", "Skippy", "425g", 9.49),
  item("js-skippy-reduced-fat", "Skippy Reduced Fat Creamy", "Skippy", "462g", 8.99),
];
